<template>
  <div class="menu-search-wrap">
    <div class="menu-search-trigger" @click="showSearchBox">
      <i class="el-icon-search"></i>
      <span class="search-hot-key"
        >菜单搜索 ( {{ isWin ? "Ctrl + K" : "⌘ + K" }} )</span
      >
    </div>
    <el-dialog
      :show-close="false"
      :append-to-body="true"
      :visible.sync="isShowSearch"
      width="540px"
      custom-class="menu-search-dialog"
      :destroy-on-close="true"
    >
      <div class="menu-search-dialog-content">
        <div class="search-input-wrapper">
          <i class="el-icon-search" @click="() => $refs.inputRef.focus()"></i>
          <el-input
            ref="inputRef"
            v-model.trim="keyword"
            type="text"
            placeholder="请输入搜索内容"
            class="search__input"
          />
          <span v-if="keyword" class="search__clear" @click="handleClearInput"
            >清除</span
          >
          <div v-if="keyword" class="search-line"></div>
          <i class="el-icon-close" @click="handleCloseDialog"></i>
        </div>
        <div v-show="keyword" class="menu-search-result-wrapper">
          <div class="search-result">
            <!-- 菜单搜索结果 -->
            <div class="search-result-title">
              导航至({{ routerList.length }})
            </div>
            <div
              v-for="(nav, index) in routerList"
              :key="index"
              class="search-result-item"
              tabindex="-1"
              @click="navigateToMenu(nav)"
            >
              <!-- <svg-icon :icon-class="nav.icon" style="margin: 5px 5px 0 0" /> -->
              <div v-html="nav.htmlStr"></div>
            </div>
            <!-- 无搜索结果 -->
            <div v-show="!routerList.length" class="no-search-result">
              没有查询到相关内容，建议换个关键词搜索，若关闭搜索框按「Esc」、点击X或点击空白处。
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sortArr } from "@/utils/tool";
// import SvgIcon from "@/components/SvgIcon.vue";

export default {
  components: {
    // SvgIcon,
  },

  data() {
    return {
      keyword: "",
      isShowSearch: false,
      routerList: [],
      menuNavs: [],
      ctrlPressed: false, // Ctrl 键是否按下
      kPressed: false, // K 键是否按下
    };
  },
  computed: {
    menus: function () {
      return sortArr(this.$store.state.login.menu);
    },
    isWin() {
      return /Win/i.test(navigator.appVersion);
    },
  },
  watch: {
    keyword(val) {
      if (val) {
        this.getRouterList();
      }
    },
  },
  mounted() {},
  created() {
    window.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  },
  methods: {
    handleKeyDown(event) {
      if (this.isShowSearch) {
        return false;
      }
      if (event.ctrlKey) {
        this.ctrlPressed = true;
      }
      if (event.keyCode === 75) {
        this.kPressed = true;
      }
      if (this.ctrlPressed && this.kPressed) {
        event.preventDefault();
        this.showSearchBox();
      }
    },
    handleKeyUp(event) {
      if (event.keyCode === 17) {
        this.ctrlPressed = false;
      }
      if (event.keyCode === 75) {
        this.kPressed = false;
      }
    },
    showSearchBox() {
      this.keyword = "";
      this.isShowSearch = true;
      this.$nextTick(() => {
        this.$refs.inputRef?.focus();
      });
    },
    handleClearInput() {
      this.keyword = "";
    },
    handleCloseDialog() {
      this.keyword = "";
      this.isShowSearch = false;
    },
    // 选中菜单后跳转到指定页面
    navigateToMenu(val) {
      this.keyword = "";
      this.$router.push({ path: `/${val.path}` });
      this.isShowSearch = false;
    },
    // 处理路由信息 - 无标题、重定向、无子菜单项不处理
    getRouterList() {
      this.routerList = [];
      let regex = new RegExp(this.keyword, "g"); // 构造正则表达式对象，采用全局匹配模式
      for (let item1 of this.menus) {
        if (item1.children && item1.children.length > 0) {
          for (let item2 of item1.children) {
            if (item2.children && item2.children.length > 0) {
              for (let item3 of item2.children) {
                if (
                  item3.menuName.indexOf(this.keyword) > -1 ||
                  item2.menuName.indexOf(this.keyword) > -1 ||
                  item1.menuName.indexOf(this.keyword) > -1
                ) {
                  const htmlStr =
                    `${item1.menuName} > ${item2.menuName} > ${item3.menuName}`.replace(
                      regex,
                      `<span class="hight-light">${this.keyword}</span>`
                    );
                  this.routerList.push({
                    htmlStr: `<div class="search-result-name"> ${htmlStr}</div>`,
                    path: item3.menuAdr,
                    icon: item3.icon,
                    fullNames: [item1.menuName, item2.menuName, item3.menuName],
                  });
                }
              }
            } else {
              if (
                item2.menuName.indexOf(this.keyword) > -1 ||
                item1.menuName.indexOf(this.keyword) > -1
              ) {
                const htmlStr = `${item1.menuName} > ${item2.menuName}`.replace(
                  regex,
                  `<span class="hight-light">${this.keyword}</span>`
                );
                this.routerList.push({
                  htmlStr: `<div class="search-result-name"> ${htmlStr}</div>`,
                  path: item2.menuAdr,
                  icon: item2.icon,
                  fullNames: [item1.menuName, item2.menuName],
                });
              }
            }
          }
        } else {
          if (item1.menuName.indexOf(this.keyword) > -1) {
            const htmlStr = `${item1.menuName}`.replace(
              regex,
              `<span class="hight-light">${this.keyword}</span>`
            );
            this.routerList.push({
              htmlStr: `<div class="search-result-name"> ${htmlStr}</div>`,
              path: item1.menuAdr,
              icon: item1.icon,
              fullNames: [item1.menuName],
            });
          }
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.menu-search-wrap {
  flex: 1;
  text-align: right;
  margin-right: 20px;
  .menu-search-trigger {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 140px;
    height: 18px;
    padding: 6px 14px;
    border-radius: 6px;
    color: #606266;
    border: 1px solid #dcdfe6;
    font-size: 13px;
    background: #f5f7fa;
    cursor: pointer;
    transition: all 0.2s;
    user-select: none;
    &:hover {
      color: #2e5ef9;
      border-color: currentColor;
      .anticon-search,
      .search-hot-key,
      &::before {
        color: inherit;
      }
    }
  }
}
</style>
<style lang="less">
.menu-search-dialog {
  border-radius: 8px !important;
  background: transparent !important;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  .el-dialog__body {
    padding: 0 !important;
    background: transparent !important;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
  }
  .el-dialog__header {
    display: none;
  }
  .menu-search-dialog-content {
    .search-input-wrapper {
      display: flex;
      align-items: center;
      height: 60px;
      margin-bottom: 8px;
      background: #fff;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      font-size: 16px !important;
      padding: 0 12px;
      .search__input {
        margin-left: 20px;
      }
      .search__clear,
      .el-icon-close {
        line-height: 1;
        font-size: 14px;
        flex-shrink: 0;
        cursor: pointer;
        &:hover {
          color: darken(#b4b8c0, 20%);
        }
      }
      .el-input__inner {
        width: 100%;
        flex-grow: 1;
        padding: 4px 0;
        border: none !important;
        box-shadow: none !important;
      }
      .search__clear {
        color: #b4b8c0;
        font-size: 14px;
      }
      .search-line {
        width: 1px;
        height: 16px;
        margin: 18px 15px;
        background: #e7eaf0;
      }
      .el-icon-close {
        color: #878a90;
      }
    }
  }
  .menu-search-result-wrapper {
    background: #fff;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 16px;
    max-height: 444px;
    overflow: auto;
    .search-result {
      .search-result-title {
        padding-bottom: 8px;
        color: #878a90;
        line-height: 20px;
        font-size: 13px;
      }
      .search-result-item {
        display: flex;
        align-items: center;
        height: 42px;
        margin: auto -16px;
        padding: 0 16px;
        cursor: pointer;
        .hight-light {
          color: #2e5ef9;
        }
      }
      .search-result-item:hover {
        background: #e6f7ff;
      }
    }
    .no-search-result {
      line-height: 20px;
      font-size: 12px;
      color: #b4b8c0;
    }
  }
}
</style>
